import Nav from '../../Global/Nav.vue'
export default {
  name: 'Users',
  components: {
    Nav
  },
  data() {
    return {
      activeTab: 'users',
      keywords: '',
      usersList: [],
      addUsersVisable: false,
      editUsersVisable: false,
      loading: true,
      usersForm: {
        user_type: '3',
        status: true
      },
      usersRules: {
        account: [
          { required: true, message: '用户名不能为空', trigger: 'commit' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'commit' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'commit' },
          { min: 8, max: 16, message: '密码长度必须8~16位', trigger: 'commit' },
          { validator: this.validatePassword, trigger: 'commit' }
        ],
        repassword: [
          { validator: this.validateRePassword, trigger: 'blur' }
        ]
      },
      editUsersForm: {
        status: true
      },
      editUsersRules: {
        account: [
          { required: true, message: '用户名不能为空', trigger: 'commit' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'commit' }
        ]
      },
      departmentList: []
    }
  },
  mounted() {
    this.usersQueryList();
  },
  methods: {
    validatePassword(rule, value, callback) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
      if (!regex.test(value)) {
        callback(new Error('密码必须包含字母数字大小写'));
      } else {
        callback();
      }
    },
    validateRePassword(rule, value, callback) {
      if (value !== this.usersForm.password) {
        callback(new Error('两次密码不一致'));
      } else {
        callback();
      }
    },
    usersTabClick(tab, event) {
      // console.log(tab, event);
    },
    usersQueryList() {
      this.$axios.get('users/list', {
        params: {
          keywords: this.keywords
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.usersList = response.data.data.data;
        }
      })
    },
    usersToggleStatus(row, index) {
      let notice = row.status ? '启用' : '禁用';
      this.$confirm('确定' + notice + '该用户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('users/toggle_status', {
          id: row.id,
          status: row.status
        })
      }).catch(() => {
        this.usersList[index].status = !row.status;
      });
    },
    addUser() {
      this.$axios.get(`basic/data/departments/list?option=1`).then((response) => {
        this.departmentList = response.data.data
      })
      setTimeout(() => {
        this.addUsersVisable = true
      })
    },
    closeAddUsers() {
      this.addUsersVisable = false;
      setTimeout(() => {
        this.usersForm = {
          user_type: '3',
          status: true
        };
      })
    },
    saveAddUsers() {
      this.$refs.usersForm.validate(valid => {
        if (valid) {
          this.$axios.post('users/save', this.usersForm).then((response) => {
            if (response.data.code === 200) {
              this.addUsersVisable = false;
              this.$notify({
                type: 'success',
                title: '提示',
                message: '添加成功!'
              })
              this.usersQueryList();
              setTimeout(() => {
                this.usersForm = {
                  user_type: '3',
                  status: true
                };
              })
            } else {
              this.$notify({
                type: 'failed',
                title: '操作失败',
                message: response.data.data
              })
            }
          })
        }
      })
    },
    userEdit(row) {
      this.$axios.get(`basic/data/departments/list?option=1`).then((response) => {
        this.departmentList = response.data.data
      })
      setTimeout(() => {
        this.editUsersVisable = true;
        this.$axios.get(`users/detail?id=` + row.id).then((response) => {
          if (response.data.code === 200) {
            this.editUsersForm = response.data.data
          } else {
            this.$notify({
              type: 'failed',
              title: '错误',
              message: response.data.data
            })
          }
        });
      })
    },
    closeEditUsers() {
      this.editUsersVisable = false;
      setTimeout(() => {
        this.editUsersForm = {
          status: true
        };
      })
    },
    saveEditUsers() {
      this.$refs.editUsersForm.validate(valid => {
        if (valid) {
          this.$axios.post('users/save', this.editUsersForm).then((response) => {
            if (response.data.code === 200) {
              this.addUsersVisable = false;
              this.$notify({
                type: 'success',
                title: '提示',
                message: '保存成功!'
              })
              this.editUsersVisable = false;
              this.usersQueryList();
              setTimeout(() => {
                this.usersForm = {
                  status: true
                };
              })
            } else {
              this.$notify({
                type: 'failed',
                title: '操作失败',
                message: response.data.data
              })
            }
          })
        }
      })
    },
    userDel(row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('users/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$notify({
              type: 'success',
              title: '提示',
              message: '删除成功!'
            });
            this.usersQueryList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Modules/Users/script.js